import TextLayout from "~/components/common/TextLayout";
import htmlContent from "~/data/legal-document/membership.html?raw";

export default function MembershipTermsPage() {
  return <TextLayout title="Membership Terms of Service" htmlContent={htmlContent} />;
}
